import React, { useRef, useState } from 'react';
import { FaImage } from 'react-icons/fa';
import useEditorStore from '../../store/editorStore';
import { frameStyles } from '../../config/constants';
import ImageEditorModal from '../modals/ImageEditorModal';
import './LogoBlock.css';

function LogoBlock({ block }) {
  const fileInputRef = useRef(null);
  const { updateBlock } = useEditorStore();
  const [showEditor, setShowEditor] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        updateBlock(block.id, { content: event.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setShowEditor(true);
  };

  // Get selected frame style
  const selectedFrame = frameStyles.find(s => s.id === block.styles.frameStyle) || frameStyles[0];
  const frameStyle = selectedFrame.style || {};

  const styles = {
    width: '100%',
    height: '100%',
    objectFit: block.styles.objectFit || 'contain',
    objectPosition: `${50 + (block.styles.offsetX || 0)}% ${50 + (block.styles.offsetY || 0)}%`,
    transform: `scale(${(block.styles.zoom || 100) / 100})`,
    borderRadius: block.styles.frameStyle && block.styles.frameStyle !== 'none' ? '0' : `${block.styles.borderRadius}px`,
    filter: `brightness(${block.styles.brightness || 100}%) contrast(${block.styles.contrast || 100}%) blur(${block.styles.blur || 0}px) saturate(${block.styles.saturation || 100}%) grayscale(${block.styles.grayscale || 0}%) sepia(${block.styles.sepia || 0}%) hue-rotate(${block.styles.hueRotate || 0}deg)`,
  };

  const wrapperStyle = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...frameStyle
  };

  const handleUpdate = (sectionId, itemId, newSettings) => {
    updateBlock(block.id, {
      styles: {
        ...block.styles,
        ...newSettings
      }
    });
  };

  return (
    <>
      <div className="logo-block" style={wrapperStyle}>
        {block.content ? (
          <img
            src={block.content}
            alt="Logo"
            style={styles}
            onDoubleClick={handleDoubleClick}
          />
        ) : (
          <div className="logo-placeholder" onClick={handleClick} style={{width: '100%', height: '100%'}}>
            <FaImage size={48} />
            <span>คลิกเพื่ออัปโหลด Logo</span>
          </div>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>

      {showEditor && (
        <ImageEditorModal
          item={{
            id: block.id,
            ...block.styles,
            imageUrl: block.content
          }}
          sectionId={null}
          onClose={() => setShowEditor(false)}
          onUpdate={handleUpdate}
        />
      )}
    </>
  );
}

export default LogoBlock;
